import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice'; 
import { COMMON_EXPORTING_STATES, COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import { componentKey, setFormList, setPayerList, setSelectedForm, setSelectedPayer, setSelectedYear, setYearList, setLoadingState, setGridData, setStatusList, setSelectedStatus, setExportFile, setFilingFee, setShouldReloadExtensionFormsList } from './ManageExtensionFormSlice';
import ManageExtensionDataService from '../../../../services/ManageExtensionDataService';
import { setGridTotal } from '../../reportssection/report/ReportSlice';
import { MANAGE_EXTENSION_LOADING_STATES } from './constants';

export const { getFilterData, getGridData, deleteForm, downloadForm, getExtensionAmount } = {
    getFilterData: (payload) => {
        return {
            type: "MANAGEEXTENSION/GET_FILTER_DATA",
            payload: payload
        }
    },
    getGridData: (payload) => {
        return {
            type: "MANAGEEXTENSION/GET_GRID_DATA",
            payload: payload
        }
    },
    deleteForm: (payload) => {
        return {
            type: "MANAGEEXTENSION/DELETE_FORM",
            payload: payload
        }
    },
    downloadForm: (payload) => {
        return {
            type: "MANAGEEXTENSION/DOWNLOAD_FORM",
            payload: payload
        }
    },
    getExtensionAmount: (payload) => {
        return {
            type: "MANAGEEXTENSION/GET_EXTENSION_AMOUNT",
            payload: payload
        }
    },
}

function* getFilterDataAsync() {

    try {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.FILTER_LOADING}))
        const response = yield ManageExtensionDataService.getFilterData();
        
        if (response?.data.Status === 1) {
            const payersList = [ ...[{label: 'Select a payer', value: ""}], ...response.data.Data.PayerList.map(payer => ({ label: payer.label, value: payer.value}))];
            yield put(setPayerList(payersList))
            yield put(setSelectedPayer(payersList[0]))

            const formList = [ ...[{label: 'Select a form', value: ""}], ...response.data.Data.FormTypeList.map(form => ({ label: form.label, value: form.value}))];
            yield put(setFormList(formList))
            yield put(setSelectedForm(formList[0]))

            const yearList = [ ...[{label: 'Select a year', value: ""}], ...response.data.Data.YearList.map(year => ({ label: year.label, value: year.value}))];
            yield put(setYearList(yearList))
            yield put(setSelectedYear(yearList[0]))

            const statusList = [ ...[{label: 'Select a status', value: ""}], ...response.data.Data.StatusList.map(status => ({ label: status.label, value: status.value}))];
            yield put(setStatusList(statusList))
            yield put(setSelectedStatus(statusList[0]))

        } else {
            yield put(addNotifications({ 
                heading: "Failed to get filter data", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({ 
            heading: "Failed to get filter data", 
            message: error?.response?.data?.Message 
        }));

    } finally {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.FILTER_READY }))
    }

}

function* getGridDataAsync(action) {

    try {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.GRID_LOADING, }))
        const response = yield ManageExtensionDataService.getGridData(action.payload);

        if (response?.data.Status === 1) {
            yield put(setGridData(response.data.Data.Data))
            yield put(setGridTotal(response.data.Data.Data.Total))

        } else {
            yield put(addNotifications({ 
                heading: "Failed to get grid data", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({ 
            heading: "Failed to get grid data", 
            message: error?.response?.data?.Message 
        }));

    } finally {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.GRID_READY }))
    }

}

function* deleteFormAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.DELETING_RECORD_LOADING }))
        const response = yield ManageExtensionDataService.deleteForm(action.payload);

        if (response?.data.Status === 1) {
            yield put(addNotifications({ 
                heading: "Success", 
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setShouldReloadExtensionFormsList(true));
        } else {
            yield put(addNotifications({ 
                heading: "Failed Deleting Form", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({ 
            heading: "Failed Deleting Form", 
            message: error?.response?.data?.Message 
        }));

    } finally {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.DELETING_RECORD_READY }))
    }

}

function* downloadFormAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.EXPORTING_FILE_LOADING }))
        const response = yield ManageExtensionDataService.pdfPreview(action.payload);

        if (response?.data.Status === 1) {
            yield put(setExportFile(response.data.Data));
        } else {
            yield put(addNotifications({ 
                heading: "Failed Downloading Form", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({ 
            heading: "Failed Downloading Form", 
            message: error?.response?.data?.Message 
        }));

    } finally {
        yield put(setLoadingState({ state: MANAGE_EXTENSION_LOADING_STATES.EXPORTING_FILE_READY }))
    }

}

function* getExtensionAmountAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Getting Extension Amount..." }))
        const response = yield ManageExtensionDataService.getExtensionAmount(action.payload);

        if (response?.data.Status === 1) {
            yield put(setFilingFee(response.data.Data));
        } else {
            yield put(addNotifications({ 
                heading: "Failed to get Extension Amount", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({ 
            heading: "Failed to get Extension Amount", 
            message: error?.response?.data?.Message 
        }));

    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getFilterData().type, getFilterDataAsync),
        takeLatest(getGridData().type, getGridDataAsync),
        takeLatest(deleteForm().type, deleteFormAsync),
        takeLatest(downloadForm().type, downloadFormAsync),
        takeLatest(getExtensionAmount().type, getExtensionAmountAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);